<aa-customer-app-layout>
  <router-outlet></router-outlet>
</aa-customer-app-layout>

<button
  type="button"
  data-cc="show-preferencesModal"
  mat-icon-button
  id="cookie-button">
  <mat-icon>cookies</mat-icon>
</button>
